export const TEST_IDS = {
  PHOTO: 'media-photo',
} as const;
